import { Bell, CaretUpDown } from "@phosphor-icons/react";
import { Link, NavLink } from "react-router-dom";

import RenderIf from "common/components/RenderIf";
import { Button } from "common/components/ui/Button";
import WorkspaceImage from "common/components/WorkspaceImage";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import type { NavItemType } from "common/types";

import MobileNav from "./MobileNav";

function MobileHeader({ navItems }: { navItems: NavItemType[] }) {
  const {
    id: workspaceId,
    icon_url: workspaceImage,
    rental_account_count: rentalAccountsCount,
    accounts_count: accountsCount,
    name,
  } = useSelectedWorkspaceContext();

  return (
    <div className="sticky top-0 z-nav flex h-20 w-full items-center justify-between gap-3 bg-white p-4 shadow-sm">
      <Link
        to="/workspaces"
        className="flex flex-1 items-center gap-x-2 rounded-3xl border border-black-200 px-3 py-2 transition-colors"
        state={{ canGoBack: true }}
      >
        <WorkspaceImage id={workspaceId} imageSrc={workspaceImage} />
        <div className="flex flex-col gap-y-1">
          <span className="line-clamp-1 break-all text-left text-md-bold">
            {name}
          </span>
          <span className="text-xs-medium text-black-500">
            {accountsCount
              ? `${accountsCount} account${accountsCount > 1 ? "s" : ""}`
              : "No accounts"}
            <RenderIf condition={!!rentalAccountsCount}>
              • {rentalAccountsCount} avatar
              {rentalAccountsCount > 1 ? "s" : ""}
            </RenderIf>
          </span>
        </div>
        <CaretUpDown size={20} className="ml-auto" />
      </Link>

      <Button intent="iconOnly" variant="ghost-black" size="lg">
        <NavLink to="notifications">
          <Bell weight="fill" />
        </NavLink>
      </Button>
      <MobileNav navItems={navItems} />
    </div>
  );
}

export default MobileHeader;
